export default __webpack_public_path__ + "static/media/babyswap.cc9e43f9.svg";